import { useMemo, type ReactElement } from 'react'
import { DateTime } from 'luxon'
import { type TinyChat } from '@terros/common'
import { useChats } from '@front/model'
import { type PageRoute, NestedNavigation } from '@components'
import { createFileRoute } from '@tanstack/react-router'

const newRoute: PageRoute = { path: '/chat/new', label: 'New Chat', icon: 'add' }

function ChatList(): ReactElement {
  const { data, isLoading } = useChats()

  const routes = useMemo(() => {
    const chats =
      data?.map<PageRoute>((chat) => {
        return { path: `/chat/${chat.sessionId}`, label: getChatTitle(chat) }
      }) ?? []
    return [newRoute, ...chats]
  }, [data])

  return <NestedNavigation collapsible={false} routes={routes} loading={isLoading} />
}

function getChatTitle(chat: TinyChat): string {
  if (chat.title) return chat.title
  if (chat.updatedAt) {
    const updated = DateTime.fromMillis(chat.updatedAt)
    return updated.toLocaleString(DateTime.DATETIME_MED)
  }
  return 'Chat'
}

export const Route = createFileRoute('/chat')({
  component: ChatList,
})
